import React from 'react';
import { LoaderContainer, LoaderSpinner } from './styled';

interface LoaderProps {
  loading?: boolean;
  pageLoader?: boolean;
  endless?: boolean;
  minHeight?: number;
  children?: React.ReactNode;
}

export const Loader: React.FC<LoaderProps> = ({
  loading,
  children,
  pageLoader,
  endless,
  minHeight
}) => {
  const spinner = (
    <LoaderContainer
      $pageLoader={pageLoader}
      $endless={endless}
      $minHeight={minHeight}
    >
      <LoaderSpinner />
    </LoaderContainer>
  );

  return <>{(loading && spinner) || children}</>;
};
